import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from 'src/app/service/Configuration/app-config.service';
import { Constant } from '../constant';
import { LocalStorageService } from '../LocalStorageService';

@Pipe({
  name: 'commaFormat'
})
export class CommaFormatPipe implements PipeTransform {

  constructor(
    private decimalPipe: DecimalPipe,
    public persistenceService: LocalStorageService,
    private constant: Constant
  ) {
    this.constant.setFormatFromStorage(persistenceService);
  }
  transform(value: any, format?: string, showCurrency?: boolean,
    currencyCode?: string, isInputField?: boolean): string | null {

    if (value == null) {
      return null;
    }
    let suffix = '';
    let isQuantityOrRate = false;
    if (typeof value === 'string') {

      const match = value.match(/(cr|dr)$/i);

      if (match) {
        suffix = ' ' + match[0]; // keep original case
        value = value.replace(match[0], '').trim();
      }
    }
    const numericValue = typeof value === 'string'
      ? Number(value.replace(/,/g, ''))
      : value;

    if (isNaN(numericValue)) {
      console.log("not a number " + numericValue);
      return value;
    }
    if (isInputField) {

      // ✅ New Logic: Remove "quantity" from the format string if present
      let cleanFormat = format;
      if (format && format.includes('quantity')) {
        cleanFormat = format.replace('quantity', '').trim();
      }
      else if (format && format.includes('rate')) {
        cleanFormat = format.replace('rate', '').trim();
      }
      // apply decimal format ONLY (no comma, no currency)
      let inputFormatted = this.decimalPipe.transform(
        numericValue,
        cleanFormat,
        'en-IN'
      );

      if (!inputFormatted) return numericValue.toString();

      // remove comma if any (safety)
      inputFormatted = inputFormatted.replace(/,/g, '');

      return inputFormatted + suffix;
    }
    // ✅ New Logic: Remove "quantity" from the format string if present
    let cleanFormat = format;
    if (format && format.includes('quantity')) {
      isQuantityOrRate = true;
      cleanFormat = format.replace('quantity', '').trim();
    }
    else if (format && format.includes('rate')) {
      isQuantityOrRate = true;
      cleanFormat = format.replace('rate', '').trim();
    }
    if (!cleanFormat) {
      return value;
    }
    // ✅ Parse format (NO fallback now)

    const parts = cleanFormat.split('.');
    const range = parts[1].split('-');
    const min = Number(range[0]);
    const max = Number(range[1]);

    // ✅ Let Angular handle everything
    // let formatted = this.decimalPipe.transform(
    //   numericValue,
    //   cleanFormat,
    //   'en-IN'
    // );

    // 🔥 MAIN FIX → ALWAYS USE Intl (correct Indian format)
    let formatted = new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: min,
      maximumFractionDigits: max
    }).format(numericValue);

    if (!formatted) return numericValue.toString();

    // ✅ Step 3: ONLY comma logic
    if (!this.constant.isCommaSeparatorEnabled) {
      formatted = formatted.replace(/,/g, '');
    }
    // ✅ Currency (ONLY if enabled)
    if (this.constant.showCurrency && !isQuantityOrRate) {
      currencyCode = this.constant.currencyCode;
      const symbol = this.getCurrencySymbol(currencyCode);
      formatted = symbol + ' ' + formatted;
    }
    return formatted + suffix;
  }
  // helper
  private getCurrencySymbol(code: string): string {
    switch (code) {
      case 'INR': return '₹';
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'GBP': return '£';
      case 'JPY': return '¥';
      case 'CNY': return '¥';
      case 'CAD': return 'C$';
      case 'AUD': return 'A$';
      case 'CHF': return 'Fr';
      case 'SGD': return 'S$';
      case 'AED': return 'د.إ';
      case 'SAR': return '﷼';
      case 'QAR': return '﷼';
      case 'KWD': return 'د.ك';
      case 'BHD': return '.د.ب';
      case 'OMR': return '﷼';
      case 'MYR': return 'RM';
      case 'THB': return '฿';
      case 'VND': return '₫';
      case 'PHP': return '₱';
      default: return code;
    }
  }
}
